var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 40.96,
    viewBox: "0 0 60 40.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5.121 40.541 C 2.528 40.541 0.427 40.541 0.427 40.541 L 0.427 0.427 C 0.427 0.427 2.528 0.427 5.121 0.427 L 54.624 0.427 C 57.216 0.427 59.318 0.427 59.318 0.427 L 59.318 40.541 C 59.318 40.541 57.216 40.541 54.624 40.541 Z",
    fill: "rgb(255,255,255)",
    strokeWidth: 0.8535483870967742,
    stroke: "rgb(217,217,217)",
    strokeMiterlimit: 3.225806451612903,
    strokeDasharray: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-935 -525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(942 548.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M5.468,0H1.924a.489.489,0,0,0-.486.416L0,9.5A.3.3,0,0,0,.3,9.844H2.114a.346.346,0,0,0,.34-.291l.407-2.576a.489.489,0,0,1,.486-.417H4.47A3.646,3.646,0,0,0,8.5,3.193,2.735,2.735,0,0,0,8.053.906,3.29,3.29,0,0,0,5.468,0ZM3.238,4.591h0l.375-2.375A.293.293,0,0,1,3.9,1.967h.245c.64,0,1.245,0,1.556.364a1.188,1.188,0,0,1,.172.989C5.684,4.591,4.712,4.591,3.772,4.591H3.238Z",
    transform: "translate(25.284 -8.832)",
    fill: "#0079c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M5.468,0H1.924a.489.489,0,0,0-.486.416L0,9.5A.3.3,0,0,0,.3,9.844H1.988a.491.491,0,0,0,.486-.416l.387-2.451a.489.489,0,0,1,.486-.417H4.47A3.646,3.646,0,0,0,8.5,3.193,2.735,2.735,0,0,0,8.053.906,3.29,3.29,0,0,0,5.468,0ZM3.238,4.591h0l.375-2.375A.293.293,0,0,1,3.9,1.967h.245c.64,0,1.245,0,1.556.364a1.188,1.188,0,0,1,.172.989C5.684,4.591,4.712,4.591,3.772,4.591H3.238Z",
    transform: "translate(0 -8.832)",
    fill: "#00457c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M3.84,0A3.906,3.906,0,0,0,.051,3.413,3.205,3.205,0,0,0,.683,6.021a2.663,2.663,0,0,0,2.138.862,3.277,3.277,0,0,0,2.349-.97l-.075.471a.3.3,0,0,0,.292.341H6.916A.491.491,0,0,0,7.4,6.311L8.32.5A.292.292,0,0,0,8.253.265a.3.3,0,0,0-.225-.1h-1.7A.293.293,0,0,0,6.039.41L5.963.885,5.846.713A2.378,2.378,0,0,0,3.84,0ZM3.746,5.084a1.431,1.431,0,0,1-1.139-.458,1.436,1.436,0,0,1-.266-1.191A1.9,1.9,0,0,1,4.242,1.8a1.433,1.433,0,0,1,1.132.461,1.465,1.465,0,0,1,.288,1.2A1.894,1.894,0,0,1,3.746,5.084Z",
    transform: "translate(8.036 -5.714)",
    fill: "#00457c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M3.84,0A3.906,3.906,0,0,0,.051,3.413,3.205,3.205,0,0,0,.683,6.021a2.663,2.663,0,0,0,2.138.862,3.277,3.277,0,0,0,2.349-.97l-.075.471a.3.3,0,0,0,.292.341H6.916A.491.491,0,0,0,7.4,6.311L8.32.5A.292.292,0,0,0,8.253.265a.3.3,0,0,0-.225-.1h-1.7A.293.293,0,0,0,6.039.41L5.963.885,5.844.713A2.373,2.373,0,0,0,3.84,0ZM3.746,5.084a1.431,1.431,0,0,1-1.139-.458,1.432,1.432,0,0,1-.266-1.191A1.9,1.9,0,0,1,4.242,1.8a1.433,1.433,0,0,1,1.132.461,1.465,1.465,0,0,1,.288,1.2A1.894,1.894,0,0,1,3.746,5.084Z",
    transform: "translate(33.32 -5.714)",
    fill: "#0079c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M7.909-6.447H6.2a.491.491,0,0,0-.407.216L3.442-2.766l-1-3.33a.493.493,0,0,0-.472-.351H.3a.3.3,0,0,0-.28.391L1.895-.543.128,1.949a.3.3,0,0,0,.241.466h1.7a.494.494,0,0,0,.4-.212L8.152-5.983a.3.3,0,0,0-.243-.464",
    transform: "translate(17.196 0.893)",
    fill: "#00457c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M1.458-6.912,0,2.342A.3.3,0,0,0,.3,2.683H1.759a.492.492,0,0,0,.486-.416L3.68-6.82a.3.3,0,0,0-.292-.341H1.751a.3.3,0,0,0-.292.249",
    transform: "translate(41.89 -1.67)",
    fill: "#0079c1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.2f5fa7f6.svg";
export { ForwardRef as ReactComponent };